import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ScrollToTop } from "./components/ScrollToTop";
import { WebsiteRoutes } from "./apps/website/WebsiteRoutes";
import { DashboardRoutes } from "./apps/dashboard/DashboardRoutes";
import { AdminRoutes } from "./apps/admin/AdminRoutes";
import { CoachRoutes } from "./apps/coach/CoachRoutes";
import { StaffRoutes } from "./apps/staff/StaffRoutes";
import { AccountRoutes } from "./apps/account/AccountRoutes";
import { CheckoutRoutes } from "./apps/checkout/CheckoutRoutes";
import { ToastProvider } from "./components/ops/ToastProvider";
import { ConfirmProvider } from "./components/ops/ConfirmProvider";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <ConfirmProvider>
            <ScrollToTop />
            <WebsiteRoutes />
            <AccountRoutes />
            <DashboardRoutes />
            <AdminRoutes />
            <CoachRoutes />
            <StaffRoutes />
            <CheckoutRoutes />
          </ConfirmProvider>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
